import React from "react";

import DashboardCard from "../../../shared/components/cards/DashBoardCard";

const ACTIVE_ADD_ID = 3;

const DashboardCards = ({ data }) => {
  if (!data) {
    return <div className="text-center">No data available</div>;
  }

  const cards = [
    {
      id: 1,
      title: "Total Agents",
      value: data.agentCount,
      classes: "color-teal",
    },
    {
      id: 2,
      title: "Total Customers",
      value: data.customerCount,
      classes: "color-teal",
    },
    { id: 3, title: "Total Ad Listings", value: data.totalAdsListed },
    {
      id: 4,
      title: "Active Ads",
      value: data.activeAds,
      classes: "color-sea-green",
    },
    {
      id: 5,
      title: "Inactive Ads",
      value: data.inActiveAds,
      classes: "color-dark-red",
    },
    {
      id: 6,
      title: "Favourited Ads",
      value: data.favouriteAds,
      classes: "color-dark-blue",
    },
    {
      id: 7,
      title: "Top Rated Agent",
      value: data.topRatedAgent || "N/A",
      classes: "fs-1-5",
    },
    {
      id: 8,
      title: "Most Viewed Country",
      value: data.mostViewedCountry || "N/A",
      classes: "fs-1-5",
    },
    {
      id: 9,
      title: "Most Viewed Property Type",
      value: data.mostUsedPropertyType || "N/A",
      classes: "fs-1-5",
    },
  ];

  return (
    <div className="row row-cols-1 row-cols-sm-2 row-cols-xl-3 g-4 dashboard-cards-container">
      {cards.map((card) => (
        <>
          <DashboardCard
            key={card.id}
            title={card.title}
            value={card.value}
            classes={card.classes}
          />
          {card.id === ACTIVE_ADD_ID && (
            <div className="col-12 w-100">
              <h5 className="dashboard-current-statistics-heading">
                Current Statistics
              </h5>
            </div>
          )}
        </>
      ))}
    </div>
  );
};

export default DashboardCards;
